export enum E_DELIVERY_METHOD {
  TRANSFER = "TRANSFER",
  NARIN_TRANSFER = "NARIN_TRANSFER",
  AROUND_CITY = "AROUND_CITY",
  RESELL_BRANCH = "RESELL_BRANCH",
  MAIN_BRANCH = "MAIN_BRANCH",
}

export const DeliveryMethodLabels: Record<E_DELIVERY_METHOD, string> = {
  [E_DELIVERY_METHOD.TRANSFER]: "จัดส่งสินค้าผ่านขนส่งเอกชน",
  [E_DELIVERY_METHOD.NARIN_TRANSFER]: "รับสินค้าผ่านรถขนส่งของทางร้าน",
  [E_DELIVERY_METHOD.AROUND_CITY]: "รับสินค้าภายในเขตเทศบาลเมืองชัยภูมิ",
  [E_DELIVERY_METHOD.RESELL_BRANCH]: "รับสาขาเยื้องประปาชัยภูมิ",
  [E_DELIVERY_METHOD.MAIN_BRANCH]: "รับสาขาตลาดสดเทศบาล 1",
};

export enum E_DELIVERY_PROVIDER {
  THAIPOST = "THAIPOST",
  SCG = "SCG",
  KERRY = "KERRY",
  FLASH = "FLASH",
  JT = "JT",
  NIM = "NIM",
}

export const DeliveryProviderLabels: Record<E_DELIVERY_PROVIDER, string> = {
  [E_DELIVERY_PROVIDER.THAIPOST]: "ไปรษณีย์ไทย",
  [E_DELIVERY_PROVIDER.SCG]: "SCG Express",
  [E_DELIVERY_PROVIDER.KERRY]: "Kerry Express",
  [E_DELIVERY_PROVIDER.FLASH]: "Flash Express",
  [E_DELIVERY_PROVIDER.JT]: "J&T",
  [E_DELIVERY_PROVIDER.NIM]: "Nim Express",
};

export const DeliveryLink: Record<E_DELIVERY_PROVIDER, string> = {
  [E_DELIVERY_PROVIDER.KERRY]: "https://th.kerryexpress.com/en/track/?track=",
  [E_DELIVERY_PROVIDER.NIM]: "https://www.nimexpress.com/web/p/tracking",
  [E_DELIVERY_PROVIDER.SCG]: "https://www.scgexpress.co.th/en/tracking/",
  [E_DELIVERY_PROVIDER.THAIPOST]: "https://track.thailandpost.com/",
  [E_DELIVERY_PROVIDER.FLASH]: "https://www.flashexpress.com/fle/tracking",
  [E_DELIVERY_PROVIDER.JT]:
    "https://www.jtexpress.co.th/service/track?waybillNo=",
};
